import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { Store } from '@ngrx/store';

import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { TestingTrailService, CommonService, ServiceWalkInService, SubscribeService } from '../../../services/index';
import { TestingTrailModel } from '../../../model/index';

@Component({
    selector: 'add-testingService-window',
    templateUrl: './addServiceTesting.component.html'
})
export class AddServiceTestingComponent implements OnInit {
    title: string;
    public pageType: string;
    public list: any[] = [];
    potCusCtrl: FormControl;
    branchList: any[] = [];
    potCusOptList: any[];
    routeCtrl: FormControl;
    routeOptList: any[];
    testingtypeCtrl : FormControl;
    branchCtrl: FormControl;
    filteredBranchList: Observable<any[]>;
    branchControl: FormControl;
    callStatusListCtrl: FormControl;
    //public referencedata: any[] = [];
    //@Input() testingdata: TestingTrailModel[] = [];
    _testingdata: any[] = [];
    callStatusList: any[] = [];
    view_type: any;

    @Input() set testingdata(data: any[]) {
        // if(data['to_branch']) {
        //     data['company_id'] = data['to_branch'];
        // }
        this._testingdata = data;
        this.view_type = this._testingdata['view_type'];
        if (this._testingdata['description']) {
            this._testingdata['description'] = this._testingdata['description'].split('<br>')[0];
        }
        this.loadClientDetails(data['client_id'],data['page_from'],data['ser_id']);
    }

    get testingdata(): any[] {
        return this._testingdata;
    }

    @Output() testingTrailLoadEvent = new EventEmitter();
    @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('testingtypeAutoComp') testingtypeAutoComp;
    @ViewChild('branchAutoComp') branchAutoComp;
    filteredTypes: Observable<any[]>;

    testingList: any[] = [];
    // trigger-variable for Ladda
    isLoading: boolean = false;
    userType: any;
    //typeList = ['Doctor', 'Others'];

    constructor(public store: Store<fromRootStore.State>, private testingTrailService: TestingTrailService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService, private serviceWalkInService: ServiceWalkInService, public subscribeService: SubscribeService) {

        this.branchCtrl = new FormControl();
        this.callStatusListCtrl = new FormControl();
        this.potCusCtrl = new FormControl();
        this.routeCtrl = new FormControl();
        //this.potCusOptList = ['Branch', 'HO','MNF'];
        this.routeOptList = ['Yes', 'No'];
        this.callStatusList = ['Open', 'Close'];

        this.testingtypeCtrl = new FormControl();
        this.filteredTypes = this.testingtypeCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterTypes(name) : this.testingList.slice());

        function hasValidStatus(input: FormControl) {
            let callStatus = input.value, retVal = null;
            if (callStatus != "Open" && callStatus != "Close") {
                retVal = { inValidCallStatus: true };
            }

            return retVal;
        }
        this.callStatusListCtrl = new FormControl('', [
            Validators.required,
            hasValidStatus.bind(this)
        ]);
        this.callStatusList = ['Open', 'Close'];
        this.branchControl = new FormControl("");
        this.filteredBranchList = this.branchControl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterBranch(name) : this.branchList.slice());
    }

    ngOnInit(): void {
        let that = this;

        this.loadClientTypeList();

        setTimeout(()=>{
            $('#testing').focus();
        },100);

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {

                return;
            }
            // that.branchList = _.filter(res.data);
            this.branchList = _.filter(res.data, function (obj) { return obj['is_hv_center'] == 'false' });

        });

        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            // if(auth['islogin'] && (auth['usertype'] == 'Admin' || auth['usertype'] == 'Super_Admin')){
                that.userType = auth['usertype'];
            // }
        });
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }



    loadClientDetails(clientID,page_from,ser_id) {
        this.singleClientDetails.loadSingleClientDetails(clientID,page_from,ser_id); //TO LOAD CLIENT OBJECT
    }
    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'testingtype_obj';
        }
        $('#' + nextEl).focus();
    }
   /* displayType(type_id: number) {
        if (type_id && this.testingList.length > 0) {
            let ftype = _.find(this.testingList, { 'id': type_id });
            return ftype['name'];
        } else {
            return '';
        }
    }*/

     displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if(this.view_type=='Give To'){
                this.branchList = _.filter(this.branchList, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['store_branch'] == 'Yes' });
            } else {
                this.branchList = _.filter(this.branchList, function (obj) { return obj['is_hv_center'] == 'false' });
            }
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';

    }

    filterTypes(name: string) {
        name = _.escapeRegExp(name);
        return this.testingList.filter(type => (new RegExp(name, 'gi').test(type.name) || new RegExp(name, 'gi').test(type.fees)));
    }

    loadClientTypeList() {
        let that = this;
        this.commonService
            .getTestingtypeList()
            .then(function(res: any) {
                that.testingList = res;
                that.testingtypeCtrl.setValue(that.testingdata['id']);
            });
    }
    onSaveTestingTrial(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        },
           
            Branch = this.testingdata['company_id'],
            Estimation = this.testingdata['estimation'];
      
       
         if (_.toNumber(Estimation) ==0) { // 11 > 10
                toast['body'] = 'Please Enter Valid Estimation. 0 is not Valid';
                this.toasterService.pop(toast);
                return;
        }

          else if (_.isEmpty(_.toString(Estimation))) {
            toast['body'] = 'Please Select Estimation ';
            this.toasterService.pop(toast);
            return;
        } 
          if (_.isEmpty(_.toString(Branch))) {
            toast['body'] = 'Please Select Send To ';
            this.toasterService.pop(toast);
            return;
        }
        if (typeof Branch =="string") { // 11 > 10
                toast['body'] = 'Please Select Valid Branch';
                this.toasterService.pop(toast);
                return;
        }

        let that = this;
        // data = {
        //     mode: this.testingdata['mode']
        // };
        this.isLoading = true;
        this.testingTrailService
            .updateServiceTesting(this.testingdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                    swal('SUCCESS', res.message, 'success');
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
    onSaveGiveToTestingTrial(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        },
           
        Branch = this.testingdata['company_id'];      
    
        if (_.isEmpty(_.toString(Branch))) {
            toast['body'] = 'Please Select Send To ';
            this.toasterService.pop(toast);
            return;
        }
        if (typeof Branch =="string") { // 11 > 10
            toast['body'] = 'Please Select Valid Branch';
            this.toasterService.pop(toast);
            return;
        }

        let that = this;
        this.isLoading = true;
        this.testingTrailService
            .updateGiveToServiceTesting(this.testingdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                    swal('SUCCESS', res.message, 'success');
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }

       onSaveMfgout(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        },
           
            Branch = this.testingdata['company_id'],
            Estimation = this.testingdata['estimation'],
            CourierNo = this.testingdata['courier_no'],
            CourierName = this.testingdata['courier_name'];
       
         if (_.toNumber(Estimation) ==0) { // 11 > 10
                toast['body'] = 'Please Enter Valid Estimation. 0 is not Valid';
                this.toasterService.pop(toast);
                return;
        }

          else if (_.isEmpty(_.toString(Estimation))) {
            toast['body'] = 'Please Select Estimation ';
            this.toasterService.pop(toast);
            return;
        } 
          if (_.isEmpty(_.toString(Branch))) {
            toast['body'] = 'Please Select Send To ';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(CourierNo))) {
            toast['body'] = 'Please Select Courier No';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(CourierName))) {
            toast['body'] = 'Please Select Courier Name ';
            this.toasterService.pop(toast);
            return;
        }

        let that = this;
        // data = {
        //     mode: this.testingdata['mode']
        // };
        this.isLoading = true;
        this.testingTrailService
            .updateManufactureOut(this.testingdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                    swal('SUCCESS', res.message, 'success');
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }

    onSaveCourierDetails(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        },

            Branch = this.testingdata['send_to_branch'],
            ReceiveCourierNo = this.testingdata['receive_courier_no'],
            ReceiveCourierName = this.testingdata['receive_courier_name'],
            SendCourierNo = this.testingdata['send_courier_no'],
            SendCourierName = this.testingdata['send_courier_name']
        if ((SendCourierNo != null && SendCourierName != null) && (SendCourierNo !== "" && SendCourierName !== "")) {
            if (_.isEmpty(_.toString(Branch))) {
                toast['body'] = 'Please Select Branch ';
                this.toasterService.pop(toast);
                return;
            }
        }
        if (_.isEmpty(_.toString(ReceiveCourierNo))) {
            toast['body'] = 'Please Select Received Courier No';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(ReceiveCourierName))) {
            toast['body'] = 'Please Select Received Courier Name ';
            this.toasterService.pop(toast);
            return;
        }

        let that = this;
        // data = {
        //     mode: this.testingdata['mode']
        // };
        this.isLoading = true;
        this.testingTrailService
            .updateCourierDetails(this.testingdata)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                    swal('SUCCESS', res.message, 'success');
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }

    onSaveRecvCourierDetails(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        },

        rec_from_courier_no = this.testingdata['rec_from_courier_no'],
        rec_from_courier_name = this.testingdata['rec_from_courier_name'];

        if (_.isEmpty(_.toString(rec_from_courier_no))) {
            toast['body'] = 'Please Select Courier No';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(rec_from_courier_name))) {
            toast['body'] = 'Please Select Courier Name ';
            this.toasterService.pop(toast);
            return;
        }

        let that = this;
        // data = {
        //     mode: this.testingdata['mode']
        // };
        this.isLoading = true;
        this.testingTrailService
            .updateRecvCourierDetails(this.testingdata)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                    swal('SUCCESS', res.message, 'success');
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }

    onSaveImportExport() {
        let that = this;
        this.testingdata['date'] = moment(new Date()).format('YYYY-MM-DD');
        this.isLoading = true;

        this.serviceWalkInService
            .addSaveImportExport(this.testingdata)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                    swal('SUCCESS', res.message, 'success');
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingTrail/addServiceTesting.component.ts